export const getClientIP = async () => {
  try {
    // Using ipify API - a free service to get client IP
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Error fetching IP:', error);
    return '';
  }
};
